// extracted by mini-css-extract-plugin
export default {"moduleListContainer":"PrimeModuleList_moduleListContainer__hCBG9","isPartOfLP":"PrimeModuleList_isPartOfLP__vngFl"};